<template>
  <section class="dateSelectorMeetings">
    <b-field :label="label">
      <b-datepicker
        v-model="value"
        ref="datepicker"
        placeholder="Select Date"
        :min-date="minDateObject"
        :max-date="maxDateObject"
        :focused-date="focusedDate"
        :events="events"
        indicators="bars"
        @input="$emit('input', value)"
        :mobileNative="false"
        :nearby-selectable-month-days="true"
      >
        Meeting days are marked above.
      </b-datepicker>
    </b-field>
  </section>
</template>

<script>
var moment = require("moment");
Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

export default {
  name: "DateSelectorMeetings",
  data() {
    return {
      value: null,
      // focusedDate: null
    };
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    minDate: {},
    maxDate: {},
  },
  methods: {
    toggle() {
      this.$refs.datepicker.toggle();
    },
  },
  computed: {
    minDateObject() {
      return moment(this.minDate)
        .startOf("day")
        .toDate();
    },
    maxDateObject() {
      return moment(this.maxDate)
        .startOf("day")
        .toDate();
    },
    focusedDate() {
      return this.minDateObject;
    },
    events() {
      var startMeeting = new Date(
        this.$store.state.meetings.meetingInfo.meeting.meetingStartDate
      );
      var endMeeting = new Date(
        this.$store.state.meetings.meetingInfo.meeting.meetingEndDate
      );
      var days = [];
      var i = startMeeting;
      while (i <= endMeeting) {
        i = i.addDays(1);
        days.push(i);
      }
      return days;
    },
  },
};
</script>

<style scoped></style>
